/*
 * Author M. Atoar Rahman
 * Title: D2 Distribution Approval
 * Description: Page for D2 Distribution Approval
 * Date: 20/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { D2ApprovalProvider } from '../centerWarehouse/d2DistributionApproval/ContextAPI';
import Index from '../centerWarehouse/d2DistributionApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function D2DistributionApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['d2-distribution-approval']) return <PermissionDenied />;

    return (
        <D2ApprovalProvider>
            <Index />
        </D2ApprovalProvider>
    );
}
